import { render } from "./LoaderComponent.vue?vue&type=template&id=0f37888e"
const script = {}

import "./LoaderComponent.vue?vue&type=style&index=0&id=0f37888e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__